import {
    GET_CURRENT_CURRENCIES
} from './constants';

const initialState = {
    currentCurrencies: {},
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_CURRENT_CURRENCIES: {
            return {
                ...state,
                currentCurrencies: action.payload,
            };
        }
        default:
            return state;
    }
};

